<template>
  <section class="container mx-auto py-6 md:pt-10 md:pb-8">
    <h2
      class="text-center sm:text-left section-heading sm:w-full mx-auto sm:mx-0"
    >
      {{ props.industryTitle }}
    </h2>
    <div
      class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-10 gap-y-3 mt-12"
    >
      <template v-if="isLoading">
        <UtilsSkeletonLoading
          v-for="i in 110"
          :key="i"
          class="w-full h-[100px]"
        />
      </template>

      <template v-else>
        <div
          v-for="item in clientsData"
          :key="item.id"
          class="client-img flex justify-center"
        >
          <NuxtImg
            format="webp"
            srcset=""
            preset="client"
            class="w-1/2 h-[100px] object-contain"
            loading="lazy"
            :src="item.attributes?.image?.data?.attributes?.url || '/'"
            :alt="item.attributes?.name || 'Logo'"
            :title="item.attributes?.name || 'Logo'"
          />
        </div>
        <template v-if="isLoadingMore">
          <UtilsSkeletonLoading
            v-for="i in 3"
            :key="i"
            class="w-full h-[100px]"
          />
        </template>
      </template>
    </div>
    <div
      v-if="clientsMeta?.pagination?.page < clientsMeta?.pagination?.pageCount"
      class="mx-auto text-center mt-12"
    >
      <CommonLoadMoreButton @click.prevent="onUpdateClients" />
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  industryId: {
    type: Number,
    required: true
  },
  industryTitle: {
    type: String,
    default: 'Industry'
  }
})

const isLoading = ref(false)
const isLoadingMore = ref(false)

const page = ref(1)
const clientsData = ref([])
const clientsMeta = ref({})

const { data } = await useSuitmediaApiData(`/api/clients`, {
  query: {
    'pagination[page]': page.value,
    'pagination[pageSize]': 18,
    'populate[image][fields][0]': 'url',
    'fields[0]': 'id',
    'fields[1]': 'name',
    'filters[industry][id]': props.industryId,
    'sort[0]': 'name'
  }
})

clientsData.value = data.value.data
clientsMeta.value = data.value.meta

// METHODS
const onUpdateClients = async () => {
  if (isLoadingMore.value) return
  if (page.value >= clientsMeta.value?.pagination?.pageCount) return

  isLoadingMore.value = true
  page.value += 1

  try {
    const res = await $suitmediaApi(`/api/clients`, {
      query: {
        'pagination[page]': page.value,
        'pagination[pageSize]': 18,
        'populate[image][fields][0]': 'url',
        'fields[0]': 'id',
        'fields[1]': 'name',
        'filters[industry][id]': props.industryId,
        'sort[0]': 'name'
      },
      retry: 3,
      retryDelay: 300
    })

    if (res?.data?.length) {
      clientsData.value.push(...res.data)
      clientsMeta.value = res.meta
    } else {
      page.value -= 1
    }
  } catch (error) {
    console.error(error.message)
    page.value -= 1
  } finally {
    isLoadingMore.value = false
  }
}
</script>

<style lang="scss" scoped></style>
